import { atom } from 'jotai'

export const columnWidthMapAtom = atom<Record<number, number>>({})
